import { render, staticRenderFns } from "./Ministerio.vue?vue&type=template&id=eef81f08&scoped=true&"
import script from "./Ministerio.vue?vue&type=script&lang=js&"
export * from "./Ministerio.vue?vue&type=script&lang=js&"
import style0 from "./Ministerio.vue?vue&type=style&index=0&id=eef81f08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef81f08",
  null
  
)

export default component.exports